import React, { useState } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  Container,
} from '@mui/material';
import moment from 'moment';
import style from '../../Tools/Style';

export default function TModalFacturasPC({ rows, seleccionar }) {
  const [term, setTerm] = useState('');
  function searchingTerm(term) {
    return function (x) {
      let nrocomprobante = '';
      if (x.nrocomprobante === null || x.nrocomprobante === undefined) {
        nrocomprobante = '';
      } else {
        nrocomprobante = x.nrocomprobante;
      }
      let nombre = '';
      if (x.cliente.nombre === null || x.cliente.nombre === undefined) {
        nombre = '';
      } else {
        nombre = x.cliente.nombre;
      }
      let apellido = '';
      if (x.cliente.apellido === null || x.cliente.apellido === undefined) {
        apellido = '';
      } else {
        apellido = x.cliente.apellido;
      }
      let fechacomprobante = '';
      if (x.fechacomprobante === null || x.fechacomprobante === undefined) {
        fechacomprobante = '';
      } else {
        fechacomprobante = x.fechacomprobante;
      }
      let fechavencimiento = '';
      if (x.fechavencimiento === null || x.fechavencimiento === undefined) {
        fechavencimiento = '';
      } else {
        fechavencimiento = x.fechavencimiento;
      }
      let totalfactura = 0;
      if (x.totalfactura === null || x.totalfactura === undefined) {
        totalfactura = 0;
      } else {
        totalfactura = x.totalfactura;
      }
      let montopagado = 0;
      if (x.montopagado === null || x.montopagado === undefined) {
        montopagado = 0;
      } else {
        montopagado = x.montopagado;
      }
      return (
        nrocomprobante.toUpperCase().includes(term.toUpperCase()) ||
        apellido.toUpperCase().includes(term.toUpperCase()) ||
        nombre.toUpperCase().includes(term.toUpperCase()) ||
        fechacomprobante.toUpperCase().includes(term.toUpperCase()) ||
        fechavencimiento.toUpperCase().includes(term.toUpperCase()) ||
        totalfactura.toString().toUpperCase().includes(term.toUpperCase()) ||
        montopagado.toString().toUpperCase().includes(term.toUpperCase()) ||
        !term
      );
    };
  }
  return (
    <Container>
      <Grid container direction="row">
        <Grid item md={4}>
          <TextField
            variant="outlined"
            name="term"
            onChange={(e) => setTerm(e.target.value)}
            label="Buscar"
          />
        </Grid>
      </Grid>

      <TableContainer
        style={style.table.tareas}
        component={Paper}
        align="center"
      >
        <Table
          style={style.table.presasi}
          size="small"
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell align="left">Factura</TableCell>
              <TableCell align="left">Cliente</TableCell>
              <TableCell align="left">Fecha Factura</TableCell>
              <TableCell align="left">Fecha de Vencimiento</TableCell>
              <TableCell align="left">Saldo a Pagar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.filter(searchingTerm(term)).map((factura) => (
              <TableRow
                key={factura.nrocomprobante}
                hover={true}
                onClick={() => seleccionar(factura)}
              >
                <TableCell align="left">{factura.nrocomprobante}</TableCell>
                <TableCell align="left">
                  {factura.cliente.nombre + ' ' + factura.cliente.apellido}
                </TableCell>
                <TableCell align="left">
                  {moment(factura.fechacomprobante).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell align="left">
                  {moment(factura.fechavencimiento).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell align="left">
                  {Intl.NumberFormat('es').format(
                    factura.totalfactura - factura.montopagado
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}
